import React from "react";
import { observer } from "mobx-react-lite";
import { IconExclamationMark } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { BPEStore } from "../ProductEditorStore";

export default observer(function ErrorMessages({
  datasetIndex,
  className,
}: {
  datasetIndex: number;
  className?: string;
}) {
  const { t } = useTranslation();

  const epdValidationError = () => {
    return BPEStore.hasEpdValidationError(datasetIndex);
  };

  const factorValidationError = () => {
    return BPEStore.hasFactorValidationError(datasetIndex);
  };

  const materialValidationError = () => {
    return BPEStore.hasMaterialValidationError(datasetIndex);
  };

  const anyErrors = () => {
    return (
      epdValidationError() ||
      factorValidationError() ||
      materialValidationError()
    );
  };

  function checkOtherErrors() {
    return factorValidationError() ? (
      <>
        {t("productEditor.factorEmptyError")}
        <br />
      </>
    ) : (
      hasMaterialError()
    );
  }

  function hasMaterialError() {
    return materialValidationError() ? (
      <>
        {t("productEditor.materialEmptyError")}
        <br />
      </>
    ) : null;
  }

  if (!anyErrors()) return <></>;
  return (
    <div
      className={clsx(
        "text-red-700 text-sm flex items-center pt-2 pb-1",
        className
      )}
    >
      <IconExclamationMark
        width={15}
        className="mr-3 bg-red-100 rounded-full h-6 w-6 p-1"
      />
      {epdValidationError() ? (
        <>
          {t("productEditor.epdEmptyError")}
          <br />
        </>
      ) : (
        checkOtherErrors()
      )}
    </div>
  );
});
